<template>
  <div id="caseTaskForm" style="width:100%">
  <form autocomplete="off">
    <!-- Keep loading until all fields rendered -->
    <div class="md-autocomplete-loading" v-show="isPromisePending || !(taskTempList.length)">
      <md-progress-spinner :md-diameter="40" :md-stroke="4" md-mode="indeterminate" />
    </div>
    <!-- Save button -->
    <CrudToolbar 
      :atShowAuditLog="atShowAuditLog" 
      :save="saveTaskSteps" 
      :form="form" 
      :$v="$v" 
      :formConfig="formConfig" 
      :btnActive="btnActive" 
      :cancel="cancel"
      :statusControlConfig="statusControlConfig"
      :assigneeControlConfig="assigneeControlConfig"
      :recordData="recordData"
      :isSaveInProgress="isSaveInProgress"
      ></CrudToolbar>

    <div class="md-layout _singleTask__form__rootLayout">
      <grid-layout
          :layout.sync="formLayout"
          :col-num="12"
          :is-draggable="false"
          :is-resizable="false"
          :auto-size="false"
          :is-mirrored="false"
          :vertical-compact="true"
          :responsive="false"
          :margin="[10, 10]"
          :use-css-transforms="true"
        >
          <grid-item v-for="(slot, slotName, index) in formConfig.slots" :id="slotName"
                    :x="slot.layout.x"
                    :y="slot.layout.y"
                    :w="slot.layout.w"
                    :h="slot.layout.h"
                    :i="slot.layout.i"
                    :key="'griditem_'+ slotName + slot.layout.i"
          >
          <div v-if="slot.editModeOnly && formConfig.pageMode == 'new'" :key="slotName" class="vue-grid-item-content">
            <h3><span class="heading">{{slot.label}}</span></h3>Create a base record to enable this section.
          </div>
          <div v-else :key="slotName" class="vue-grid-item-content">
            <div v-if="$v && $v.form && showRequirements" class="requirementsNotice">
              <h4>The following fields require attention:</h4>
              <template v-for="(slot, slotName, index) in formConfig.slots">
                <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">
                  <template v-if="$v.form[name] && $v.form[name].$invalid">
                  <p :key="`${name}-${index}`" :data-target="name" @click="scrollToField(name)" class="required-field-label">
                      <span class="fa-stack fa-sm">
                        <i class="far fa-circle fa-stack-2x text-danger"></i>
                        <i class="fas fa-times fa-stack-1x text-danger"></i>
                        <!-- <i class="far fa-circle fa-stack-2x text-success"></i>
                        <i class="fas fa-check fa-stack-1x text-success"></i> -->
                      </span>
                      {{field.label}}
                  </p>
                    </template>
                  </template>
                </template>
            </div>
              <h3><span class="heading">{{slot.label}}</span></h3>
            <md-field v-if="taskTempList.length && ('edit' == formConfig.pageMode || 'new' == formConfig.pageMode) && 'basic' == slotName" class="_uiKitInput" style="margin-right: 30px;">
              <label >Template</label>
              <md-select v-model="taskTemp" name="taskTemp" id="taskTemp" :pageMode="formConfig.pageMode" @md-selected="taskSelected(taskTemp)">
                  <md-option v-for="titem in taskTempList" :value="titem.id" :key="titem.id"> {{ titem.subject }} </md-option>
              </md-select>
            </md-field>
            
            <template v-for="(field, name) in formConfig.fields" v-if="field.slot === slotName">
              
              <CrudCheckbox
                v-if="field.type == 'checkbox'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                  :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudCheckbox>
            
              <CrudSearchModal
                v-else-if="field.type == 'searchmodal'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field" :recordData="recordData" :filter="taskCaseIdFilter(field.filter)"></CrudSearchModal>

              <CrudSwitch
                v-else-if="field.type == 'switch'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                  :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSwitch>

              <CrudDatepicker
                v-else-if="field.type == 'datepicker'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                  :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudDatepicker>

              <CrudSelect
                v-else-if="field.type == 'select'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                  :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudSelect>

              <CrudAutocomplete
                v-else-if="field.type == 'autocomplete'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                  :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudAutocomplete>

              <CrudJson
                v-else-if="field.type == 'json'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudJson>

              <CrudId
                v-else-if="field.type == 'id'" :key="name" class="field"
                  :iframeModelId="iframeModelId"
                :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudId>

              <CrudText
                v-else :key="name" class="field"
                  :iframeModelId="iframeModelId"
                  :name="name" :form="form" :pageMode="formConfig.pageMode" :$vo="$v.form" :field.sync="field"></CrudText>

            </template>
          </div>
          <gridItemHook />

        </grid-item>
      </grid-layout>
    </div>
    
  </form>
  <!-- List of steps on view page -->
  <div>
    <template>
      <div 
        v-if="(isIframeMode && ('view' == formConfig.pageMode || 'assignee' == formConfig.pageMode)) || ((formConfig.pageMode == 'view' || formConfig.pageMode == 'assignee') && recordData)"
        class="md-layout-item md-size-100 _taskLayoutCard" 
        id="viewTaskSteps"
      >
        <!-- <br> -->
          <div class="row">
            <h5 class="title" >
              <span class="heading">Task Steps</span>
            </h5>
            <div class="col-8" v-if="lines && lines[0] && null !== lines[0].title">
              <table border="1" id="taskTable" class="taskTable table table-striped">
                <thead class="thead-dark">
                  <tr>
                    <th style="width:10%"></th>
                    <th style="width:20%" scope="col">Title</th>
                    <th scope="col">Description</th>
                    <th style="width:20%" scope="col">Status</th>
                    <th style="width:20%" scope="col">Is Available</th>
                  </tr>
                </thead>
                  <tr v-for="item in lines" :key="item.order">
                    <td>
                      <CaseTaskViewStepComponent
                        class="_taskForm__step"
                        :step="item"
                        :isCompleteInOrder="recordData ? recordData.isCompleteInOrder : false"
                        :atStepUpdate="onStepUpdate"
                        :isRefreshing="isPromisePending"
                        :isVisible="true"
                        @busy="onTaskStepBusy"
                        @free="onTaskStepFree"
                      />
                    </td>
                    <td>{{ item.title }}</td>
                    <td><div v-html="item.description" v-linkified></div></td>
                    <td>{{ item.status }}</td>
                    <td>{{ getTaskStepIsAvailableLabel(item) }}</td>
                  </tr>
              </table>
            </div>
            <div v-if="!lines || !lines[0] || null === lines[0].title"> Steps Not Defined </div>
          </div>
      </div>
    </template>
    <!-- Add steps form on edit and new page -->
    <template>
      <div v-if="(formConfig.pageMode == 'edit') || (formConfig.pageMode == 'new')">
        <h5 class="title" >
          <md-icon>view_list</md-icon><span class="heading">Task Steps</span>
        </h5>
        
        <draggable tag="div" :list="lines" class="list-group" handle=".handle" v-bind="dragOptions" @end="dragend">
          <div v-for="(line, index) in lines" v-bind:key="index" class="row" style="margin-bottom: 5px;">
            <div class="md-layout step-layout" >
              <div class="md-layout-item md-size-5">
                <i class="fa fa-align-justify handle"></i>
              </div>
              <div class="md-layout-item md-size-20 field-layout align-input">
                <md-field class="_uiKitInput _uiKitDraggableInput">
                    <label>Title</label>
                    <md-input v-model="line.title" type="text" v-on:input="debounceInput"></md-input>
                </md-field>
              </div>
              <div class="md-layout-item md-size-25 field-layout">
                  <md-field class="_uiKitInput _uiKitDraggableInput">
                        <label>Description</label>
                        <md-textarea class="text-area" v-model="line.description" v-on:input="debounceInput"></md-textarea>
                  </md-field>
              </div>
              <div class="md-layout-item md-size-20 field-layout align-input">
                <md-field class="_uiKitInput _uiKitDraggableInput">
                      <label >Status</label>
                      <md-select :disabled="recordData && recordData.id && recordData.isCompleteInOrder && !line.isAvailable" v-model="line.status" name="status" id="status" :form="form" :pageMode="formConfig.pageMode" @md-selected="debounceInput">
                          <md-option value="Open" selected>Open</md-option>
                          <md-option value="In Progress">In Progress</md-option>
                          <md-option value="Complete">Complete</md-option>
                      </md-select>
                </md-field>
              </div>
              <div class="md-layout-item md-size-5">
                <md-button class="md-primary md-just-icon" v-if="index + 1 === lines.length" @click="addLine"><md-icon >add_circle</md-icon></md-button>
              </div>
              <div class="md-layout-item md-size-5">
                <md-button class="md-primary md-just-icon" @click="removeLine(index,line)"><md-icon >clear</md-icon></md-button>
              </div>
            </div>
          </div>
        </draggable>  
      </div>
    </template>
  </div>
  <div v-show="scrollActive">
      <CrudToolbar 
        v-if="(formConfig.pageMode == 'new') || (formConfig.pageMode != 'new')" 
        :save="saveTaskSteps" 
        :form="form" 
        :$v="$v" 
        :formConfig="formConfig" 
        :btnActive="btnActive" 
        :cancel="cancel"
      ></CrudToolbar>
  </div> 
 </div>
</template>

<script>
  import _ from "lodash";
  import RecordForm from '@/mixins/RecordForm';
  import VueGridLayout from 'vue-grid-layout';
  import CaseTaskViewStepComponent from '@/components/DynamicForm/CaseTaskView/CaseTaskViewStepComponent';
  import Amplify, { API, graphqlOperation } from 'aws-amplify';
  import * as mutations from '@/graphql/mutations';
  import * as queries_custom from '@/graphql/queries_custom';
  import * as query from '@/graphql/queries';
  import { required, numeric, minLength } from "vuelidate/lib/validators";
 
  import draggable from "vuedraggable";
  import Swal from "sweetalert2";
  import { filter } from 'minimatch';

  const gridItemHook = {
    mounted(){
      // [i] This pushes each gridItem into this.gridItems below for config-form
      this.$parent.$parent.$parent.gridItems.push(this.$parent);
    },
    render(h){
      return h('div', [h('div',{attrs: {contentEditable: true, class: 'editable'}})])
    }
  };

  export default {
    name: "CustomTaskForm",
    mixins: [RecordForm],
    props: {
      atShowAuditLog: {
        type: Function,
        required: false
      },
    },
    components: {
        draggable,
        GridLayout: VueGridLayout.GridLayout,
        GridItem: VueGridLayout.GridItem,
        gridItemHook,
        CaseTaskViewStepComponent,
    },
    data () {
      return {
        statusControlConfig: {
          id: 'taskStatusToolbarControl',
          label: 'Status',
          showFilter: true,
          columnFilterList: [],
          defaultSelectedValue: this.recordData && this.recordData.status ? this.recordData.status.replace(/_/g, " ") : '',
          filterListQueryId: "getListTaskStatusEnum",
          responseFieldName: "listTaskStatusEnum",
          updateMutationId: "updateTask",
          fieldToBeUpdate: "status",
          updatedById: "taskUpdatedById",
        },
        assigneeControlConfig: {
          id: 'taskAssigneeToolbarControl',
          field: this.formConfig.fields.taskUserId,
          label: 'Assignee',
          showFilter: true,
          defaultSelectedValue: this.formConfig.fields.taskUserId.searchTerm,
          filterListQueryId: "searchUsers",
          updateMutationId: "updateTask",
          fieldToBeUpdate: "taskUserId",
          updatedById: "taskUpdatedById",
        },
        formLayout: [//default value so that at least it works
          {"x":0,"y":0,"w":2,"h":2,"i":"0"},
          {"x":2,"y":0,"w":2,"h":4,"i":"1"},
          {"x":4,"y":0,"w":2,"h":5,"i":"2"},
          {"x":6,"y":0,"w":2,"h":3,"i":"3"},
          {"x":8,"y":0,"w":2,"h":3,"i":"4"},
          {"x":10,"y":0,"w":2,"h":3,"i":"5"},
          {"x":0,"y":5,"w":2,"h":5,"i":"6"},
          {"x":2,"y":5,"w":2,"h":5,"i":"7"},
          {"x":4,"y":5,"w":2,"h":5,"i":"8"},
          {"x":6,"y":4,"w":2,"h":4,"i":"9"},
          {"x":8,"y":4,"w":2,"h":4,"i":"10"},
          {"x":10,"y":4,"w":2,"h":4,"i":"11"},
          {"x":0,"y":10,"w":2,"h":5,"i":"12"},
          {"x":2,"y":10,"w":2,"h":5,"i":"13"},
          {"x":4,"y":8,"w":2,"h":4,"i":"14"},
          {"x":6,"y":8,"w":2,"h":4,"i":"15"},
          {"x":8,"y":10,"w":2,"h":5,"i":"16"},
          {"x":10,"y":4,"w":2,"h":2,"i":"17"},
          {"x":0,"y":9,"w":2,"h":3,"i":"18"},
          {"x":2,"y":6,"w":2,"h":2,"i":"19"}
        ],
        gridItems: [],
        btnActive: false,
        lines: [],
        taskTempList: [],
        workflowTaskTempList: [],
        taskTemp:"",
        blockRemoval: true,
        dragging: false,
        stepCount: 0,
        taskCrudCompleted: null,
        scrollActive: false
      }
    },
    beforeMount() {
      let layout = [];
      this.$loopo(this.formConfig.slots, (slot) => {
        layout.push(slot.layout);
      });
      if (layout.length) {
        this.formLayout = layout;
      }
    },
    updated() {
      this.gridItems.forEach(gridItem => {
        gridItem.autoSize();
      });
    },
    watch: {
      lines () {
        this.blockRemoval = this.lines.length <= 1
      },
      recordData () {
        let steps = this.$reduce(this, 'recordData.steps.items');
        if(steps && steps.length) {
          /**
           * ATLAS-1009
           * @see https://zeamster.atlassian.net/browse/ATLAS-1009
           * If task is complete in order then make first step which is not
           * complete as available
           */
          steps = _.orderBy(steps, 'order');
          if (this.recordData.isCompleteInOrder) {
            const firstAvailableStep = steps.find(_step => {
              return _step.status && 'complete' != _step.status.toLowerCase();
            });
            steps.map(_step => {
              _step.isAvailable = false;
            });
            if (firstAvailableStep) {
              firstAvailableStep.isAvailable = true;
            }
          }
          this.lines = steps;
        } else {
          this.lines = [];
          
          // ATLAS-1210 -- If lines set to [], in task edit mode, user not able to see option to add steps
          this.lines.push({
            title: null,
            description: null,
            status: 'Open'
          })           
        }
        const taskTemplateId = this.$reduce(this, 'recordData.taskTemplate.id');
        if (taskTemplateId) {
          this.taskTemp = taskTemplateId;
        }

        // Moves StatusControl to fixed toolbar
        let caseTaskToolbar = window.document.getElementById("caseTaskToolbar");
        if (caseTaskToolbar) {
          let taskStatusToolbarControl = window.document.getElementById("taskStatusToolbarControl");
          if (taskStatusToolbarControl && taskStatusToolbarControl.parentElement.id !== "caseTaskToolbar") {
            let parent = taskStatusToolbarControl.parentElement;
            caseTaskToolbar.append(taskStatusToolbarControl);
          }
          let taskAssigneeToolbarControl = window.document.getElementById("taskAssigneeToolbarControl");
          if (taskAssigneeToolbarControl && taskAssigneeToolbarControl.parentElement.id !== "caseTaskToolbar") {
            let parent = taskAssigneeToolbarControl.parentElement;
            caseTaskToolbar.append(taskAssigneeToolbarControl);
            if (parent.id !== "caseTaskToolbar") {
              //parent.remove();
            }
          }
        }
      },
      'formConfig.fields.taskUserId.searchTerm': {
        handler: function() {
            console.log("currentItem Changed");
            if (this.assigneeControlConfig) {
              this.assigneeControlConfig.defaultSelectedValue = this.formConfig.fields.taskUserId.searchTerm
            }
        },
      },

    },
    computed: {
      dragOptions() {
        return {
          animation: 200,
          group: "description",
          disabled: false,
          ghostClass: "ghost"
        };
      },
      showRequirements() {
        let result = false;
         if (this.formConfig && this.formConfig.pageMode === 'new' && this.$v.form.$invalid && !this.$route.params.id) {
          result = true;
        }
        if(this.formConfig.pageMode === 'edit'){
          if(this.recordData && this.recordData.id && this.$v.form.$invalid){
            result = true;
          }
        }
        return result;
      },
    },
    methods: {
      handleScroll() {
        this.scrollActive = true;
      },
      onStepUpdate() {
        this.refresh();
        window.$bus.$emit('caseTaskView.forceUpdate');
      },
      onTaskStepBusy() {
        this.isPromisePending = true;
      },
      onTaskStepFree() {
        this.isPromisePending = false;
      },
      getTaskStepIsAvailableLabel(step) {
        if (!this.recordData || !this.recordData.isCompleteInOrder) {
          return 'Yes';
        }
        return step.isAvailable ? 'Yes' : 'No';
      },
      taskCaseIdFilter: function (filtertype) { 
        if(this.recordData && this.recordData.case) { 
          return [{"match": {[filtertype]: this.recordData.case.id }}]; 
        } 
      },	
      debounceInput: _.debounce(function (e) {
        this.btnActive = true;
      }, 500),
      dragend() {
        this.btnActive = true;
      },
      scrollToField(target){
        const selector = `.vue-grid-item-content [name="${target}"]`;
        const eleTarget = document.querySelector(selector);
        if (eleTarget) {
          const eleParent = eleTarget.closest('.field')
          if(eleParent) {
            eleParent.scrollIntoView({
              behavior:"smooth"
            });
          } else {
            eleTarget.scrollIntoView({
              behavior:"smooth"
            });
          }
        }
      },
      taskSelected (templateId) {
          if ((templateId != 'open')) {
              if(this.checkFieldsChanges()){
                  Swal.fire({
                    title: 'Do you want to apply the template?',
                    text: "You have made changes that will be overwritten.",
                    type: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes'
                  }).then((result) => {
                    if (result.value) {
                      this.addTemplateValues(templateId);
                    }else{
                      this.taskTemp = 'open';
                    }
                  })
              } else {
                this.addTemplateValues(templateId);
              }
          }         
      },
      addTemplateValues (templateId) {
        this.$loopo(this.taskTempList, (value, key) => {
            if (value.id == templateId) {
                this.$v.form.type.$model = value.type;
                this.$v.form.subject.$model = value.subject;
                this.$v.form.priority.$model = value.priority;
                this.$v.form.status.$model = value.status;
                this.$v.form.isCompleteInOrder.$model = value.isCompleteInOrder;
                /**
                 * ATLAS-530: Assignee assigned to Template is not getting 
                 * populated when applied to Task
                 */
                if (value.user && value.user !== null) {
                  (($this) => {
                    $this.searchTerm = value.user.given_name + ' ' + value.user.family_name;
                    this.form.taskUserId = value.user.id;
                  })(this.formConfig.fields.taskUserId);
                } else {
                  //if selected template has no user then set assignee field to blank
                  (($this) => {
                    $this.searchTerm = '';
                    this.form.taskUserId = '';
                  })(this.formConfig.fields.taskUserId);
                }

                if (value.steps.items.length) {
                  this.lines = _.orderBy(value.steps.items, 'order');
                } else {
                  this.lines = [];
                  this.addLine();
                } 
            }
        });
      },
      checkFieldsChanges () {
          if (this.$v.form.taskUserId.$anyDirty || this.$v.form.subject.$anyDirty || this.$v.form.priority.$anyDirty || this.$v.form.type.$anyDirty || this.$v.form.status.$anyDirty) {
            return true;
          } else {
            return false;
          }
      },
      /**
       * ATLAS-691 New Application workflow - Task Form validation
       * Validate Task
       */
      async validateTaskForm() {
        if (
          this.recordData && this.recordData.case &&
          this.recordData.case.services && this.recordData.case.services.items &&
          this.recordData.case.services.items.length
        ) {
          let serviceItems = this.recordData.case.services.items;
          let statusList = ["Sub_Withdrawn", "Approved", "Withdrawn"];
          let caseServiceResult = [];
          let text = "";

          //loop through all the related services
          for (let i = 0; i < serviceItems.length; i++) {
            const item = serviceItems[i];
            let params = {limit: 999};
            params.filter = {"id": {"eq": item.id}};
            let error = null;
            
            //query api to get records from Service model
            let response = await API.graphql(graphqlOperation(query['searchCaseServices'], params))
              .catch(err => {
                console.log(err);
                error = err;
              });
            
            if (!error) {
              caseServiceResult.push({
                id: response.data.searchCaseServices.items[0].service.id,
                status: response.data.searchCaseServices.items[0].service.status,
                dateFirstProcessing: response.data.searchCaseServices.items[0].service.dateFirstProcessing,
                closeDate: response.data.searchCaseServices.items[0].service.closeDate
              });
            }
          }

          caseServiceResult.forEach((item, index) => {
            if (this.form.subject == "Check Application Status" && !statusList.includes(item.status)) {
              text = 'Related Service\'s Status should be "Sub_Withdrawn", "Approved" or "Withdrawn"';
            }
            if (this.form.subject == "Check for Batches" && item.dateFirstProcessing == null) {
              text = "Related Service's First Processing Date field should be filled";
            }
            /**
             * ATLAS-1102 - validation
             */
            if (this.form.subject.toLowerCase() === "close account confirm" && item.closeDate == null) {
              text = "Related Service's Close Date field should be filled";
            }
          });

          if (text) {
            //show alert dialog
            Swal.fire({
              title: "Task can not be updated!",
              text: text,
              type: "warning",
              confirmButtonClass: "md-button md-success btn-fill",
              buttonsStyling: false
            });
            return false;
          } else {
            return true;
          }
        } else {
          return true;
        }
      },
      async saveTaskSteps() {
        /**
         * ATLAS-691 New Application workflow - Task Form validation
         * Validate when task is edited
         * ATLAS-1102 - validation
         */
        if (
          this.formConfig.isTemplateActive === false &&
          this.formConfig.pageMode == 'edit' &&
          (this.form.subject == "Check Application Status" || this.form.subject == "Check for Batches" || this.form.subject == "Close Account Confirm")
        ) {
          let error = null;

          //wait until response is returned
          let resp = await this.validateTaskForm()
            .catch(err => {
              error = err;
            });

          if (error) {
            return;
          }
          //stop processing if response is false
          if(!resp) {
            return;
          }
        }

        this.taskCrudCompleted = null;
        this.isPromisePending = true;
        this.isSaveInProgress = true; //disable Save button
        this.$v.$touch();

        if(this.$v.$invalid) {
          this.$c.log('save(): unable to save, $v.invalid');
          this.isPromisePending = false;
          return;
        }
        let data = {};
        const form = this.form;
        const fields = this.formConfig.fields;

        this.$loopo(fields, (field, name) => {
          if (!field.fields) {
            if (typeof form[name] !== 'undefined' && form[name] !== null) {
              if (field.type === 'datepicker') {
                try{
                  data[name] = form[name].toUTCString();
                }catch (e) {
                  data[name] = form[name].toString();
                  console.log('datepicker try catch ....',data[name])
                }
              } else {
                data[name] = form[name];
              }
            }
          } else {
            if (field.type === 'json') {
              data[name] = JSON.stringify(form[name].fields);
            }
           }
        });

        // We should not send any empty strings on create
        if (this.formConfig.pageMode == 'new') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                delete data[name];
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  delete data[name];
                }
              }
            }
          });
        }
        if (this.formConfig.pageMode == 'edit') {
          this.$loopo(fields, (field, name) => {
            if (!field.fields) {
              if (data[name] === "") {
                data[name] = null;
              }
            } else {
              if (field.type === 'json') {
                let isEmpty = true;
                this.$loopo(field.fields, (ffield, fname) => {
                  let formValue = form[name].fields[fname];
                  if (formValue !== '') {
                    isEmpty = false;
                  }
                });
                if (isEmpty) {
                  data[name] = null;
                }
              }
            }
          });
        }

        if (this.formConfig.isTemplateActive) {
          data.isTemplate = true;
        }
        
        if (this.taskTemp) {
          data.taskTaskTemplateId = this.taskTemp;
        }

        /**
         * ATLAS-828 - ATLAS-810 Impact: Dashboard Logic is working on 
         * CLOSED status to find Tasks Done Today
         */
        if (data.status === 'Completed') {
          data.dateCompleted = new Date().toISOString();
        }

        /**
         * ATLAS-530 Make current user the default assignee when creating
         * a New Task from Case details -> Add Task popup -> New tab
         */
        if(
          this.formConfig.pageMode == 'new' && 
          this.formConfig.isTemplateActive === false && 
          !data.taskUserId
          ) {
          data.taskUserId = this.$Session.userId;
        }
      
        // if case is not a template and is not isCompleteInOrder then mark
        // task as isAvailable
        if (!data.isTemplate) {
          if (this.recordData && (!this.recordData.case || !this.recordData.case.isCompleteInOrder)) {
            data.isAvailable = true;
          }
        }
        
        this.$c.log('data has been prepared form=', data);

        //for casetask
        if(this.groupIndex && this.orderIndex) {
          //when task is created from case, $route.params.id is set as taskCaseId
          if(!this.taskCrud) {
            data.taskCaseId = this.$route.params.id;
          }
          data.group = this.groupIndex;
          data.order = this.orderIndex;
          this.$emit('dialogChange', false);
        }

        //create a unique task template entry 
        //if saveAsTemplate is checked true
        let saveAsTemplate = false;
        if(data.isTemplate === true) {
          saveAsTemplate = true;
        }

        data.isTemplate = false;
        if (this.formConfig.isTemplateActive === false) {
          await this.createTask(data).then(result => {
            this.taskCrudCompleted = result;
            if(saveAsTemplate){
                if(data.taskUserId == null) delete data.taskUserId;
                delete data.id;
                delete data.taskCaseId;
                delete data.group;
                delete data.order;
                data.isTemplate = true;
                let arrData = [];
                this.taskTempList.filter(_item => {
                  if(_item.subject == data.subject && _item.isTemplate === true ){
                    arrData.push(_item)
                  }
                });
                if (arrData.length) {
                  console.log('temp is present');
                }
                else {
                  this.createTask(data).then(result => {
                    console.log('taskTempCompleted ',result)
                  }).catch(error => { 
                    this.$c.log("error while getting user", error);
                  });
                }
              }                              
            }).catch(error => {              
              this.$c.log("error while getting user", error);
            });
          }

          //Create Task Template
          if (saveAsTemplate && this.formConfig.isTemplateActive === true) {
            console.log('saveAsTemplate == true')
            data.isTemplate = true;
            delete data.taskCaseId;
            delete data.group;
            delete data.order;
            await this.createTask(data);
          }
        },

        async createTask(data){
        
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByFieldName');
          if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
            data[updatedByFieldName] = this.$reduce(this, '$Session.userId');
          }

          return new Promise(async (resolve, reject) => {
            if (this.formConfig.removeFields && this.formConfig.removeFields.length) {
              this.formConfig.removeFields.forEach(item => {
                delete data[item];
              });
            }
            let query = this.getMutation(this.formConfig.pageMode === 'edit'? this.formConfig.actions.update : this.formConfig.actions.save);          
            const result = await API.graphql(graphqlOperation(query, {input: data}))
            .then(result => {
              let responseKey = ((this.formConfig.pageMode === 'new' ||  this.formConfig.pageMode === 'view' || this.formConfig.pageMode === 'assignee')? 'create' : 'update') + this.formConfig.objectName;
              let responseId = result.data[responseKey].id
              this.$c.log("success! responseKey = " + responseKey);
              this.$c.log("success! responseId = " + responseId);
              this.$emit('taskCreated', result.data[responseKey]);
              window.$bus.$emit('caseTaskView.forceUpdate');
              let promiseArr = [];
              
              /**
               * @see https://zeamster.atlassian.net/browse/ATLAS-646
               * @see CustomCaseConfigForm.vue
               */
              let isFirstTaskStepMadeAvailable = false;
              let promiseTaskData = result.data[responseKey];

              this.$loopo(this.lines, (value, key) => {
                let setOrderVal = parseInt(key) + 1;
                  
                // mark the first step that is not complete as available
                // check ATLAS-646 comment above
                // ATLAS-879 - <Task>< Task group> Complete In Order Updates
                // @see https://zeamster.atlassian.net/browse/ATLAS-879
                // Updated the logic for status = 'closed_by_workflow' as per ATLAS-1170
                if (promiseTaskData && promiseTaskData.isCompleteInOrder) {
                  if (0 == value.group && 'completed' != status && 'closed_by_workflow' != status) {
                    value.isAvailable = true;
                  } else {
                    value.isAvailable = false;
                  }
                } else {
                  value.isAvailable = true;
                }
                
                if (value.id && this.formConfig.pageMode === 'edit') {
                  promiseArr.push(this.updateSteps(value, responseId, setOrderVal));
                } else {
                  promiseArr.push(this.createSteps(value, responseId, setOrderVal));
                } 
              });   
              Promise.allSettled(promiseArr).then((resultPromise) => {
                /**
                 * setTimeout is needed here as the AuditTrail Lambda function
                 * takes around 1 second to complete and calling loadData
                 * immediately without delay will not fetch recent change logs
                 * subscriptions will trigger in the meantime and show recent
                 * change logs and then data will be overwritten by empty 
                 * data from loadData call
                 */
                setTimeout(() => {
                  this.isPromisePending = false;
                  this.isSaveInProgress = false; //enable Save button
                  if (true === this.isIframeMode) {                          
                    this.loadData(result.data[responseKey]);
                    this.formConfig.pageMode = 'view';         
                    return resolve('success');
                  }
                  if(this.taskCrud) {      
                    if(this.taskCrudCompleted){    
                      this.$router.push(this.formConfig.listPath + '/' + this.taskCrudCompleted.data[this.taskCrudCompleted.responseKey].id);       
                      this.loadData(this.taskCrudCompleted.data[this.taskCrudCompleted.responseKey]);                           
                    }else{
                      this.$router.push(this.formConfig.listPath + '/' + responseId);                            
                      this.loadData(result.data[responseKey]);
                      this.formConfig.pageMode = 'view';                           
                    }                     
                    resolve({ data: result.data, responseKey: responseKey});
                  }else{
                    if(this.formConfig.redirectTemp){
                      this.$router.push(this.formConfig.listPath + '/' + responseId);         
                      this.loadData(result.data[responseKey]);
                    }         
                    resolve('success');       
                  }
                  this.getTasksList();   
                }, 1000);
              })
            })
            .catch(error => {
              this.$c.log(error);
              reject (error);
            });
          }) 
        },       
        
        createSteps (stepsData, taskId, orderVal) {
          //ATLAS-815 Default Task Step status - Open
          let inputstepsData = {
            title: stepsData.title,
            description: stepsData.description,
            taskStepTaskId: taskId,
            status: (stepsData.status === null ? "Open" : stepsData.status),
            isAvailable: stepsData.isAvailable,
            order: orderVal
          };
        
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskStepFieldName');
          if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
            inputstepsData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
          }
          
          let gqlRequest = graphqlOperation(mutations['createTaskStep'], {input: inputstepsData});
          this.$c.log('gqlRequest create steps', gqlRequest);
          return API.graphql(gqlRequest)
        },

        updateSteps (stepsData, taskId, orderVal) {
          //ATLAS-815 Default Task Step status - Open
          let inputstepsData = {
            id: stepsData.id,
            title: stepsData.title,
            description: stepsData.description,
            taskStepTaskId: taskId,
            status: (stepsData.status === null ? "Open" : stepsData.status),
            isAvailable: stepsData.isAvailable,
            order: orderVal
          };
        
          /**
           * ATLAS-877 - Add Updatedby to all Models in the Schema
           * @see https://zeamster.atlassian.net/browse/ATLAS-877
           */
          const updatedByFieldName = this.$reduce(this, 'formConfig.updatedByTaskStepFieldName');
          if (true === this.formConfig.hasUpdatedBy && updatedByFieldName) {
            inputstepsData[updatedByFieldName] = this.$reduce(this, '$Session.userId');
          }
          
          let gqlRequest = graphqlOperation(mutations['updateTaskStep'], {input: inputstepsData});
          this.$c.log('gqlRequest update step', gqlRequest);
          return API.graphql(gqlRequest)
        },        

      async deleteSteps (stepsData) {
          let inputstepsData = {
            id: stepsData.id
          };
          let gqlRequest = graphqlOperation(mutations['deleteTaskStep'], {input: inputstepsData});
          this.$c.log('gqlRequest delete step', gqlRequest);

        const result = await API.graphql(gqlRequest)
        .then(result => {
          this.$c.log(result);
        })
        .catch(error => {
          this.$c.log(error);
        });
      },
      removeLine (lineId, stepItem) {
        if(this.formConfig.pageMode == 'edit') {
          if(stepItem.id){
            Swal.fire({
              title: 'Are you sure you want delete step '+stepItem.title+'?',
              text: "This step is associated with the task",
              type: 'warning',
              showCancelButton: true,
              confirmButtonColor: '#3085d6',
              cancelButtonColor: '#d33',
              confirmButtonText: 'Yes'
            }).then((result) => {
              if (result.value) {
                this.deleteSteps(stepItem);
                if (!this.blockRemoval && this.lines.length > 1 ) {
                    this.lines.splice(lineId, 1)
                }else if( this.blockRemoval && this.lines.length === 1 ){
                  console.log('length is zero')
                  this.lines = [];
                  this.lines.push({
                    title: null,
                    description: null,
                    status: null             
                  })
                }
              }
            }) 
          } 
          else {
            if (this.blockRemoval) {
              this.lines.splice(lineId, 1);
              this.lines.push({
                title: null,
                description: null,
                status: null
              });  
            }
            else this.lines.splice(lineId, 1);
          }
        } 
        else if(this.formConfig.pageMode == 'new') {
          if (this.blockRemoval) {
            this.lines.splice(lineId, 1);
            this.lines.push({
              title: null,
              description: null,
              status: null
            });  
          }
          else this.lines.splice(lineId, 1);
        }
      },
      addLine () {
        let checkEmptyLines = this.lines.filter(line => line.number === null)
        if (checkEmptyLines.length >= 1 && this.lines.length > 0) return
        this.lines.push({
          title: null,
          description: null,
          status: 'Open'
        })  
      },
      async getTasksList () {
        let params = {limit:999}, operation, response = [];
        params.filter = {esQuery: JSON.stringify({"match": {"isTemplate": true }})};
        params.limit = 999;
        operation = graphqlOperation(queries_custom['searchTasksSteps'], params);
        console.log('query-------------------------------------------', operation);
        const result = await API.graphql(operation);
        let taskTempates = result.data.searchTasks.items;

        //sort template name alphabetically
        const sortedItems = _.sortBy(taskTempates,[function(o) { return o.subject.toLowerCase(); }]);

        if(sortedItems.length) {
          sortedItems.filter(_item => {
            if(_item.hasWorkflow) {
              this.workflowTaskTempList.push(_item)
              console.log('skip this task template as it is of workflow...')
            } else {
              this.taskTempList.push(_item)
            }
          });         
        }       
        this.btnActive = false;
      }
    },
    mounted () { 
      this.addLine();
      this.getTasksList();
      // a task was updated using the case task view - force task update
      // this is needed to sync task between main window and sidepanel
      window.$bus.$on('caseTaskView.updated', () => this.refresh());
      window.addEventListener('scroll', this.handleScroll);

      // Reset the toolbar (form controls and tab navigation)
      let caseTaskToolbar = window.document.getElementById("caseTaskToolbar");
      if (caseTaskToolbar) {
        caseTaskToolbar.innerHTML = '';

        let sidePanelBody = window.document.getElementById("sidePanelBody");
        if (sidePanelBody) {
          let detailsTab = sidePanelBody.querySelector("#details");
          if (detailsTab) {
            let toolbar = detailsTab.querySelector("#caseTaskForm .md-toolbar");
            if (toolbar) {
              let controls = toolbar.getElementsByTagName('ul')[0];
              if (controls && controls.parentElement.id !== 'caseTaskToolbar') {
                if (controls.id !== "movedCaseTaskToolbarFormControls" && !window.document.getElementById("movedCaseTaskToolbarFormControls")) {
                  controls.id = "movedCaseTaskToolbarFormControls";
                  caseTaskToolbar.append(controls);
                }
              }
            }  

            let taskStatusToolbarControl = window.document.getElementById("taskStatusToolbarControl");
            if (taskStatusToolbarControl && taskStatusToolbarControl.parentElement.id !== "caseTaskToolbar") {
              caseTaskToolbar.append(taskStatusToolbarControl);
            }

            let taskAssigneeToolbarControl = window.document.getElementById("taskAssigneeToolbarControl");
            if (taskAssigneeToolbarControl && taskAssigneeToolbarControl.parentElement.id !== "caseTaskToolbar") {
              let parent = taskAssigneeToolbarControl.parentElement;
              caseTaskToolbar.append(taskAssigneeToolbarControl);
              if (parent.id !== "caseTaskToolbar") {
                //parent.remove();
              }
            }
          }
        }
      }

    },
    beforeDestroy() {
      window.removeEventListener('scroll', this.handleScroll);
    },
  };
</script>

<style lang="scss" scoped>
  .crud-toolbar {
    .md-button {
      margin-top: .3125rem !important;
    }
    .md-card .md-card-header.md-card-header-icon i {
      margin-top: -8px;
    }
  }
  input.is-danger {
    border: 2px solid red;
  }

  .md-content.md-theme-default.md-tabs-content {
    background-color: transparent !important;
    height: auto !important;
  }

  form {
    .md-field.md-autocomplete {
      .md-input-action.md-button.md-clear {
        width: 20px;
        height: 20px;
        min-width: 20px;
        right: 25px;
        top: 5px;
      }
    }

    fieldset {
      border: none;
      padding: 0;
      width: 100%;
      margin: 0;

      legend {
        margin-bottom: 0;
        width: 100%;
        padding-left: 0;
        margin-left: 0;

        h5 {
          margin-bottom: 0;
        }
      }
    }
  }

 .md-tab .md-layout .md-card.md-theme-default {
    margin-bottom: 0;
    margin-top: 15px;
  }

   #taskTable{
    border-collapse: collapse;
    border: 1px solid #d6d2d2;
    width: auto;
    text-align: center;
  }
  #taskTable td{
    border-left: 0px none;
    padding:5px;
    
  }
  .step-layout{
    border: 0.5px solid #ccc; 
    background-color: #f4fcfc;
    padding: 10px 0;
  }
  .handle {
    float: left;
    padding-top: 18px;
    padding-bottom: 18px;
  }
  .field-layout .md-field{
    padding-bottom: 8px;
    margin: 5px 0 0;
  }
  .md-button.md-primary, .md-button.md-primary:hover, .md-button.md-primary:focus, .md-button.md-primary:active, .md-button.md-primary.active, .md-button.md-primary:active:focus, .md-button.md-primary:active:hover, .md-button.md-primary.active:focus, .md-button.md-primary.active:hover, .open > .md-button.md-primary.dropdown-toggle, .open > .md-button.md-primary.dropdown-toggle:focus, .open > .md-button.md-primary.dropdown-toggle:hover {
    background-color: #b3aead !important;
    width: 10px;
    height: 27px;
  }
  .md-layout-item .md-size-5{
    padding-top: 26px;
    padding-bottom: 26px;
  }
  .md-has-textarea .text-area{
    padding-left:0px !important;
    padding-right:30px !important;
  }
  h5.title {
    margin-bottom: 10px !important;
  }
  .align-input { 
    padding-top:9px; 
  }

  #caseTaskForm #viewTaskSteps {
    padding: 0 !important;
  }

  .requirementsNotice {
    background-color: lightyellow;
    border: 1px solid black;
    border-radius: 5px;
    width: 100%;
    padding: 10px;
    margin-bottom: 10px;

    h4 {
      margin-top: 0;
      margin-bottom: 0;
      font-size: 14px;
      font-weight: bold;
    }
    p {
      margin-bottom: 0;
      margin-top: 5px;
    }
    .fa-stack.fa-sm {
      font-size: 10px;
    }
    .required-field-label {
      color: #2196f3;
      cursor: pointer;
    }
  }
  
</style>
